import { render, staticRenderFns } from "./Panduan.vue?vue&type=template&id=1a0f815a&"
import script from "./Panduan.vue?vue&type=script&lang=js&"
export * from "./Panduan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports